import React, { useEffect, useState } from 'react';
import ReactTable from 'react-table';
import { Box, Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import DisputesChildTable from './DisputesChildTable';
import { cfPath } from '../../../utilities/UrlPaths';
import { formatPhoneNumber } from '../../../utilities/helpers';

const DisputesTable = ({ catalogs, showMultipleSessions }) => {
  const [expanded, setExpended] = useState({});

  const columns = [
    {
      expander: true,
      Header: '',
      width: 33,
      Expander: ({ isExpanded }) => (
        <div>
          {isExpanded ? <FontAwesomeIcon icon="angle-up" /> : <FontAwesomeIcon icon="angle-down" />}
        </div>
      ),
      style: {
        cursor: 'pointer',
        fontSize: 20,
        padding: '0',
        textAlign: 'center'
      }
    },
    {
      Header: 'Buyer',
      minWidth: 210,
      id: 'firstName',
      className: 'wrap-table-cell cell-font-size',
      sortable: false,
      resizable: false,
      Cell: ({ original }) => {
        const {
          bidderAddress,
          paddleNumber,
          lastName,
          firstName,
          channel,
          approvalID,
          mobilePhone,
          email
        } = original;

        if (!firstName || !bidderAddress) {
          return null;
        }

        return (
          <Box>
            <a href={`${cfPath()}/al/bidders/viewBidder.cfm?approvalID=${approvalID}`}>
              {lastName}, {firstName} ({channel})
            </a>
            <Typography variant="body2">Paddle No. {paddleNumber}</Typography>
            <Typography variant="body2">
              {mobilePhone && `${formatPhoneNumber(mobilePhone)}`}
            </Typography>
            <Typography variant="body2">{email}</Typography>
          </Box>
        );
      }
    },
    {
      Header: '# Items',
      accessor: 'memberSums.lotCount',
      id: 'lotCount',
      minWidth: 80,
      className: 'wrap-table-cell cell-font-size',
      sortable: false,
      resizable: false,
      Cell: ({ original }) => (
        <Typography variant="body2" fontWeight="bold">
          {original.memberSums.lotCount}
        </Typography>
      )
    },
    {
      Header: 'Hammer',
      accessor: 'hammer',
      id: 'hammer',
      className: 'cell-font-size',
      sortable: false,
      minWidth: 75,
      Cell: ({ original }) => (
        <Typography variant="body2" fontWeight="bold">
          {original.memberSums.sumHammer}
        </Typography>
      )
    },
    {
      Header: 'BP',
      accessor: 'buyPrem',
      id: 'buyPrem',
      className: 'cell-font-size',
      sortable: false,
      minWidth: 75,
      Cell: ({ original }) => (
        <Typography variant="body2" fontWeight="bold">
          {original.memberSums.sumBuyPrem}
        </Typography>
      )
    },
    {
      Header: 'Live Fee',
      accessor: 'liveFee',
      id: 'liveFee',
      className: 'cell-font-size',
      sortable: false,
      minWidth: 75,
      Cell: ({ original }) => (
        <Typography variant="body2" fontWeight="bold">
          {original.memberSums.sumLiveFee}
        </Typography>
      )
    },
    {
      Header: 'Payable',
      accessor: 'payble',
      id: 'result-payable',
      className: 'cell-font-size',
      sortable: false,
      minWidth: 75,
      Cell: ({ original }) => (
        <Typography variant="body2" fontWeight="bold">
          {original.memberSums.sumPayable}
        </Typography>
      )
    }
  ];

  useEffect(() => {
    if (catalogs.length) {
      const defaultExpandedRows = catalogs.map((element, index) => ({ [index]: true }));
      setExpended(defaultExpandedRows);
    }
  }, [catalogs]);

  return (
    <Box mt={2}>
      <ReactTable
        minRows={0}
        pageSize={catalogs.length}
        data={catalogs}
        expanded={expanded}
        columns={columns}
        showPagination={false}
        style={{ width: '100%' }}
        onExpandedChange={expanded => setExpended(expanded)}
        SubComponent={row => (
          <DisputesChildTable catalogs={row.original} showMultipleSessions={showMultipleSessions} />
        )}
        className="-striped -highlight"
      />
    </Box>
  );
};

export default DisputesTable;
